import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VCard,{staticClass:"bubble-card",attrs:{"elevation":"5","ripple":false}},[_c(VCardTitle,{class:_vm.computedTitleClass},[_vm._t("card-title")],2),_c(VCardText,{staticClass:"bubble-card__content"},[_vm._t("default")],2),(_vm.$slots['card-actions'])?_c(VCardActions,{staticClass:"bubble-card__actions"},[_vm._t("card-actions")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }